module.exports = __webpack_public_path__ + "static/img/banner0.cf5b46a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner0.png
// module id = V8MZ
// module chunks = 0